import { Measurement, MeasurementMetric, RollupFunction } from '@kentik/ui-shared/query/query.types';
import { getRollupKey, isAggregateQuery } from '@kentik/ui-shared/query/query';
import { getMeasurementMetric } from '@kentik/ui-shared/query/measurements';
import { getDatasetPrefix } from 'app/views/ude/dataviews/util/unitFormatter';
import QueryRequest from 'app/stores/ude/QueryRequest';

export interface RollupResult {
  key: string;
  metric: string;
  metricInfo: MeasurementMetric | null;
  fn: RollupFunction | 'total';
  values: number[];
  prefix: string;
  unit?: string;
}

export default function getRollupResults(queryRequest: QueryRequest, measurement: Measurement | null): RollupResult[] {
  const { query, results } = queryRequest;
  if (!measurement) {
    return [];
  }

  const queryWithMeasurement = { ...query, measurementObj: measurement };

  if (isAggregateQuery(queryWithMeasurement)) {
    return query.metrics.map((metric) => {
      const key = metric.name;
      const metricInfo = getMeasurementMetric(measurement, metric.name);
      const values = results.rows.map((result) => result.rollups[metric.name]);
      const unit = metricInfo?.Unit;
      const prefix = getDatasetPrefix(values, unit);
      return { key, metric: metric.name, metricInfo, fn: 'total', values, prefix, unit };
    });
  }

  const metricOrder = new Map(query.metrics.map((m, idx) => [m.name, idx]));
  const sortedRollups = [...query.rollups].sort(
    (a, b) => (metricOrder.get(a.metric) ?? Infinity) - (metricOrder.get(b.metric) ?? Infinity)
  );

  return sortedRollups.map((rollup) => {
    const key = getRollupKey(rollup);
    const metricInfo = getMeasurementMetric(measurement, rollup.metric);
    const values = results.rows.map((result) => result.rollups[key]);
    const unit = metricInfo?.Unit;
    const prefix = getDatasetPrefix(values, unit);
    return { key, metric: rollup.metric, metricInfo, fn: rollup.fn, values, prefix, unit };
  });
}
